import type { GraphCardProps } from '../graph-card.ui';
import type { GraphCardKind } from './graph-card.types';
import { timeSeriesFixture } from './time-series.fixture';

type GraphCardExample = Pick<
  GraphCardProps,
  'title' | 'chart' | 'series' | 'periods' | 'data' | 'unit' | 'legend' | 'shadow'
> & {
  /** size=card 의 코멘트(없으면 코멘트 영역이 없다) */
  comment?: string;
  /** 연결매출 스위치를 보일지(켜 둔 상태) */
  connected?: boolean;
};

/** Figma GraphCard(2047:17792)의 kind 6벌. 확인 페이지가 size card · popup 으로 늘어놓는다 */
export const graphCardFixture: Record<GraphCardKind, GraphCardExample> = {
  revenue: {
    title: '매출 / 영업이익',
    chart: 'line',
    series: 'double',
    periods: ['quarter', 'year'],
    data: timeSeriesFixture.revenue,
    unit: timeSeriesFixture.unit,
    connected: true,
    comment:
      '2024년 4분기 매출이 전 분기보다 23% 늘었습니다. 신규 B2B 계약 3건이 반영된 결과입니다.',
  },
  cash: {
    title: '현금성 자산',
    chart: 'bar',
    series: 'single',
    periods: ['quarter'],
    data: timeSeriesFixture.cash,
    unit: timeSeriesFixture.unit,
    comment: '2024년 4분기에 Series B 투자금 50억원이 들어와 현금성 자산이 늘었습니다.',
  },
  employ: {
    title: '총 고용 인원',
    chart: 'bar',
    series: 'double',
    periods: ['quarter'],
    data: timeSeriesFixture.employ,
    comment: '개발 인력을 중심으로 채용이 이어지고 있습니다. 39세 이하 비중은 66%입니다.',
  },
  'business-kpi': {
    title: '비즈니스 KPI',
    chart: 'line',
    series: 'dual-axis',
    periods: ['quarter'],
    data: timeSeriesFixture.kpi,
    legend: [
      { series: 1, label: '월간 활성 사용자' },
      { series: 2, label: '유료 고객 수' },
    ],
    comment: '월간 활성 사용자가 8분기 연속 늘었습니다.',
  },
  'impact-kpi': {
    title: '임팩트 KPI',
    chart: 'line',
    series: 'dual-axis',
    periods: ['quarter'],
    data: timeSeriesFixture.kpi,
    legend: [
      { series: 1, label: '탄소 감축량' },
      { series: 2, label: '취약계층 고용 인원' },
    ],
    comment: '탄소 감축량은 목표의 92%를 달성했습니다.',
  },
  valuation: {
    title: '회수 및 평가 총액',
    chart: 'bar',
    series: 'single',
    periods: ['quarter', 'year'],
    data: timeSeriesFixture.cash,
    unit: timeSeriesFixture.unit,
    shadow: 'default',
  },
};
